import './publicPath.js';

import {createApp} from 'vue';
import App from '@/App.vue';

const app = createApp(App);
app.config.globalProperties.$publicPath = __webpack_public_path__;
app.mount('#container');
